import { Youtube, Facebook, Twitter, Mail } from "lucide-react";

export const SOCIALS = [
  {
    key: "youtube",
    label: "YouTube",
    handle: "@newways-today",
    href: "https://www.youtube.com/@newways-today",
    icon: Youtube,
  },
  {
    key: "facebook",
    label: "Facebook",
    handle: "NewWaysToday",
    href: "https://www.facebook.com/profile.php?id=61587251771353",
    icon: Facebook,
  },
  {
    key: "twitter",
    label: "X / Twitter",
    handle: "@NewWaysToday",
    href: "https://x.com/NewWaysToday",
    icon: Twitter,
  },
  {
    key: "email",
    label: "Email",
    handle: "ProfessorKnowOne@gmail.com",
    href: "mailto:ProfessorKnowOne@gmail.com",
    icon: Mail,
  },
];

// Pre-computed once at module load — avoids re-filtering on every render.
export const FOLLOW_SOCIALS = SOCIALS.filter((s) => s.key !== "email");
